<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import { storeElementID, storeData, storeSelectedIcon, storeContact } from '../../library/scripts/Store.svelte'
	import { get_initial_values, get_element_tags, get_blocks, string_to_fontsize } from '../builderUtils'
	import { reorder_layout } from '../../library/scripts/utils'
	import ColorSelector from '../ColorSelector.svelte'
	import SizeSelector from '../SizeSelector.svelte'
	import SelectValues from '../SelectValues.svelte'
	import Shader from '../../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../../library/ShadersAndSpinners/SpinnerCircle.svelte'

	export let width

	const globals = getContext('globals')
	const fsXS = globals.fsXS
	const icon = globals.icon
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	let iconAlignTitleL = globals.colorDark
	let iconAlignTitleC = globals.colorDark
	let iconAlignTitleR = globals.colorDark
	let iconWeightTitle = globals.colorDark
	let iconStyleTitle = globals.colorDark
	let iconDecoTitle = globals.colorDark
	let iconWeightAddressTitle = globals.colorDark
	let iconStyleAddressTitle = globals.colorDark
	let iconDecoAddressTitle = globals.colorDark
	let iconWeightAddressDetails = globals.colorDark
	let iconStyleAddressDetails = globals.colorDark
	let iconWeightContactLeft = globals.colorDark
	let iconStyleContactLeft = globals.colorDark
	let iconWeightContactRight = globals.colorDark
	let iconStyleContactRight = globals.colorDark
	let mainTool = globals.mainTool
	let subTool = globals.subTool
	const fontFamily = globals.fontFamily
	const fontSize = globals.fontSize

	let mainToolHover = globals.mainToolHover
	let subToolHover = globals.subToolHover

	let idSelect1 = 'selFont'
	let idSelect2 = 'selSize'

	//show tools
	let generalTool1 = false
	let generalTool2 = false
	let generalTool3 = false
	let generalTool4 = false
	let generalTool5 = false
	let generalTool6 = false

	let showTool0 = false
	let showTool1 = false
	let showTool2 = false
	let showTool3 = false
	let showTool4 = false
	let showTool5 = false
	let showTool6 = false
	let showTool7 = false
	let showTool8 = false
	let showTool9 = false
	let showTool10 = false
	let showTool11 = false
	let showTool12 = false
	let showTool13 = false
	let showTool14 = false
	let showTool15 = false
	let showTool16 = false
	let showTool17 = false
	let showTool18 = false

	let elementID
	let config
	let blocks
	let blockID

	//set border icons
	let icon16 = false
	let icon17 = false
	let icon18 = false
	let icon19 = false
	let icon20 = false

	let icon16Color = iconColor
	let icon17Color = iconColor
	let icon18Color = iconColor
	let icon19Color = iconColor
	let icon20Color = iconColor
	let icon21Color = iconColor
	let icon22Color = iconColor
	let icon23Color = iconColor

	//change layout order
	let shaderChangeOrder = false

	//css selections
	let buttonBg
	let buttonBorderColor
	let buttonBorderRadius
	let buttonBorderWidth
	let buttonFontColor
	let buttonFontHover
	let buttonFontFamily
	let buttonFontSize
	let buttonHover
	let buttonText
	let cityText
	let containerLeftBg
	let containerRightBg
	let containerLeftPaddingTop
	let containerLeftPaddingBottom
	let containerRightPaddingTop
	let containerRightPaddingBottom
	let countryText
	let emailText
	let sibHeight
	let infoAddressColor
	let infoAddressFontFamily
	let infoAddressFontSize
	let infoAddressMarginBottom
	let infoAddressWeight
	let infoAddressStyle
	let infoContactColor
	let infoContactFontFamily
	let infoContactFontSize
	let infoLeftPadding
	let infoNameColor
	let infoNameFontFamily
	let infoNameFontSize
	let infoNameMarginBottom
	let infoNameStyle
	let infoNameWeight
	let infoNameDeco
	let marginTop
	let marginBottom
	let inputBg
	let inputFocus
	let inputBorder
	let inputFontColor
	let inputFontFamily
	let inputFontSize
	let inputShadowBlur
	let inputShadowColor
	let inputShadowX
	let inputShadowY
	let layoutOrder
	let nameText
	let padding
	let phoneText
	let streetText
	let titleAlign
	let titleBackgroundColor
	let titleColor
	let titleFontFamily
	let titleFontSize
	let titleFontStyle
	let titleFontWeight
	let titleFontDeco
	let titlePadding
	let titleText
	let titleBgOpac
	let containerLeftOpac
	let shadowColor
	let shadowX
	let shadowY
	let shadowBlur
	let containerRightOpac
	let infoContactLeftColor
	let infoContactLeftStyle
	let infoContactLeftWeight
	let infoContactRightColor
	let infoContactRightStyle
	let infoContactRightWeight
	let map
	let mapHeight
	let mapWidth
	let mapBgColor
	let mapBgOpac
	let mapBorderColor
	let mapBorderStyle
	let mapBorderWidth
	let mapShadowColor
	let mapShadowX
	let mapShadowY
	let mapShadowBlur
	let tSX
	let tSY
	let tSB
	let tSC
	let borderTopRadius
	let borderBottomRadius
	let borderLeftWidth
	let borderLeftStyle
	let borderLeftColor
	let borderTopWidth
	let borderTopStyle
	let borderTopColor
	let borderRightWidth
	let borderRightStyle
	let borderRightColor
	let borderBottomWidth
	let borderBottomStyle
	let borderBottomColor
	let blockTitleHeight
	let blockTitleMT
	let blockTitleMB
	let blockTitleValign

	//stative ID for getElementById in SelectValues
	const idColor1 = '101'
	const idColor2 = '102'
	const idColor3 = '103'
	const idColor4 = '104'
	const idColor5 = '105'
	const idColor6 = '106'
	const idColor7 = '107'
	const idColor8 = '108'
	const idColor9 = '109'
	const idColor10 = '110'
	const idColor11 = '111'
	const idColor12 = '112'
	const idColor13 = '113'
	const idColor14 = '114'
	const idColor15 = '115'
	const idColor16 = '116'
	const idColor17 = '117'
	const idColor18 = '118'
	const idColor19 = '119'
	const idColor20 = '120'
	const idColor21 = '121'
	const idColor22 = '122'
	const idColor23 = '123'
	const idMarginTop = '3'
	const idMarginBottom = '4'
	const idPadding = '5'
	const idShadowX = '6'
	const idShadowY = '7'
	const idShadowBlur = '8'
	const idInputShadowX = '9'
	const idInputShadowY = '10'
	const idInputShadowBlur = '11'
	const idFormPaddingTop = '12'
	const idFormPaddingBottom = '13'
	const idButtonRadius = '14'
	const idInfoLeftPadding = '15'
	const idMapWidth = '16'
	const idMapHeigth = '17'
	const idMapBorderWidth = '18'
	const idMapShadowX = '19'
	const idMapShadowY = '20'
	const idMapShadowBlur = '21'
	const idTitlePadding = '22'
	const idTSX = '23'
	const idTSY = '24'
	const idTSB = '25'
	const idBorderWidth = '26'
	const idBTradius = '27'
	const idBBradius = '28'
	const idTitleHeight = '29'
	const idTitleMT = '30'
	const idTitleMB = '31'

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			blocks = value.blocks
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	//set the initial css values from config.json
	$: if (elementID === 'Contact') {
		const tags = get_element_tags(elementID)
		blockID = tags[0]
		const values = get_initial_values(elementID, blocks, tags)
		buttonBg = values[0]
		buttonBorderColor = values[1]
		buttonBorderRadius = values[2]
		buttonBorderWidth = values[3]
		buttonFontColor = values[4]
		buttonFontHover = values[5]
		buttonFontFamily = values[6]
		buttonFontSize = values[7]
		buttonHover = values[8]
		buttonText = values[9]
		cityText = values[10]
		containerLeftBg = values[11]
		containerRightBg = values[12]
		containerLeftPaddingTop = values[13]
		containerLeftPaddingBottom = values[14]
		containerRightPaddingTop = values[15]
		containerRightPaddingBottom = values[16]
		countryText = values[17]
		emailText = values[18]
		sibHeight = values[19]
		infoAddressColor = values[20]
		infoAddressFontFamily = values[21]
		infoAddressFontSize = values[22]
		infoAddressMarginBottom = values[23]
		infoAddressWeight = set_details_weight(values[24])
		infoAddressStyle = set_details_style(values[25])
		infoContactColor = values[26]
		infoContactFontFamily = values[27]
		infoContactFontSize = values[28]
		infoLeftPadding = values[29]
		infoNameColor = values[30]
		infoNameFontFamily = values[31]
		infoNameFontSize = values[32]
		infoNameMarginBottom = values[33]
		infoNameStyle = set_address_title_style(values[34])
		infoNameWeight = set_address_title_weight(values[35])
		infoNameDeco = set_address_title_deco(values[36])
		marginTop = values[37]
		marginBottom = values[38]
		inputBg = values[39]
		inputFocus = values[40]
		inputBorder = values[41]
		inputFontColor = values[42]
		inputFontFamily = values[43]
		inputFontSize = values[44]
		inputShadowBlur = values[45]
		inputShadowColor = values[46]
		inputShadowX = values[47]
		inputShadowY = values[48]
		layoutOrder = values[49]
		map = values[50]
		nameText = values[51]
		padding = values[52]
		phoneText = values[53]
		streetText = values[54]
		titleBackgroundColor = values[56]
		titleColor = values[57]
		titleFontFamily = values[58]
		titleFontSize = values[59]
		titleFontStyle = set_title_style(values[60])
		titleFontWeight = set_title_weight(values[61])
		titleFontDeco = set_title_deco(values[62])
		titlePadding = values[63]
		titleText = values[64]
		titleBgOpac = values[65]
		containerLeftOpac = values[66]
		shadowColor = values[67]
		shadowX = values[68]
		shadowY = values[69]
		shadowBlur = values[70]
		containerRightOpac = values[71]
		infoContactLeftColor = values[72]
		infoContactLeftStyle = set_contact_left_style(values[73])
		infoContactLeftWeight = set_contact_left_weight(values[74])
		infoContactRightColor = values[75]
		infoContactRightStyle = set_contact_right_style(values[76])
		infoContactRightWeight = set_contact_right_weight(values[77])
		mapHeight = values[78]
		mapWidth = values[79]
		mapBgColor = values[80]
		mapBgOpac = values[81]
		mapBorderColor = values[82]
		mapBorderStyle = values[83]
		mapBorderWidth = values[84]
		mapShadowColor = values[85]
		mapShadowX = values[86]
		mapShadowY = values[87]
		mapShadowBlur = values[88]
		tSX = values[89]
		tSY = values[90]
		tSB = values[91]
		tSC = values[92]
		borderTopRadius = values[93]
		borderBottomRadius = values[94]
		borderLeftWidth = values[95]
		borderLeftStyle = values[96]
		borderLeftColor = values[97]
		borderTopWidth = values[98]
		borderTopStyle = values[99]
		borderTopColor = values[100]
		borderRightWidth = values[101]
		borderRightStyle = values[102]
		borderRightColor = values[103]
		borderBottomWidth = values[104]
		borderBottomStyle = values[105]
		borderBottomColor = values[106]
		blockTitleMB = values[107]
		blockTitleMT = values[108]
		blockTitleHeight = values[109]
		titleAlign = set_icon_BTA(values[55])
		blockTitleValign = set_icon_BTVA(values[110])
		set_icon_color('booking', 'none')

		if (borderLeftWidth > 0) {
			icon16 = true
			set_icon_color('Block', 'left')
		}
		if (borderTopWidth > 0) {
			icon17 = true
			set_icon_color('Block', 'top')
		}

		if (borderRightWidth > 0) {
			icon18 = true
			set_icon_color('Block', 'right')
		}

		if (borderBottomWidth > 0) {
			icon19 = true
			set_icon_color('Block', 'bottom')
		}

		if (borderLeftWidth > 0 && borderTopWidth > 0 && borderRightWidth > 0 && borderBottomWidth > 0) {
			icon16 = true
			icon17 = true
			icon18 = true
			icon19 = true
			icon20 = true
			set_icon_color('Block', 'all')
		}
	}

	const set_css_tag = (cssTag, cmd) => {
		blocks.forEach((block) => {
			if (block.blockName === 'contact') {
				if (cmd === 'cMT') block.marginTop = cssTag

				if (cmd === 'cMB') block.marginBottom = cssTag

				if (cmd === 'cP') block.padding = cssTag

				if (cmd === 'cSC') block.shadowColor = cssTag

				if (cmd === 'cSX') block.shadowX = cssTag

				if (cmd === 'cSY') block.shadowY = cssTag

				if (cmd === 'cSB') block.shadowBlur = cssTag

				if (cmd === 'cISX') block.inputShadowX = cssTag

				if (cmd === 'cISY') block.inputShadowY = cssTag

				if (cmd === 'cISB') block.inputShadowBlur = cssTag

				if (cmd === 'cIPT') {
					block.containerLeftPaddingTop = cssTag
					block.containerRightPadingTop = cssTag
				}

				if (cmd === 'cIPB') {
					block.containerLeftPaddingBottom = cssTag
					block.containerRightPadingBottom = cssTag
				}

				if (cmd === 'tBg') block.titleBackgroundColor = cssTag

				if (cmd === 'tH') block.titleHeight = cssTag

				if (cmd === 'tMT') block.titleMT = cssTag

				if (cmd === 'tMB') block.titleMB = cssTag

				if (cmd === 'tfColor') block.titleColor = cssTag

				if (cmd === 'tfSize') block.titleFontSize = cssTag

				if (cmd === 'titleSC') block.titleShadowColor = cssTag

				if (cmd === 'titleSX') block.titleShadowX = cssTag

				if (cmd === 'titleSY') block.titleShadowY = cssTag

				if (cmd === 'titleSB') block.titleShadowBlur = cssTag

				if (cmd === 'tfFamily') block.titleFontFamily = cssTag

				if (cmd === 'tfAlign') block.titleAlign = cssTag

				if (cmd === 'tfVAlign') block.titleValign = cssTag

				if (cmd === 'tfWeight') block.titleFontWeight = block.titleFontWeight === 'bold' ? 'normal' : 'bold'

				if (cmd === 'tfStyle') block.titleFontStyle = block.titleFontStyle === 'italic' ? 'normal' : 'italic'

				if (cmd === 'tfUnder') block.titleFontDeco = block.titleFontDeco === 'underline' ? 'none' : 'underline'

				if (cmd === 'fBg') block.containerLeftBg = cssTag

				if (cmd === 'fInput') block.inputBg = cssTag

				if (cmd === 'fIFocus') block.inputFocus = cssTag

				if (cmd === 'fColor') block.inputFontColor = cssTag

				if (cmd === 'fBorder') block.inputBorder = cssTag

				if (cmd === 'fSColor') block.inputShadowColor = cssTag

				if (cmd === 'fFFamily') block.inputFontFamily = cssTag

				if (cmd === 'fFSize') block.inputFontSize = cssTag

				if (cmd === 'bBR') block.buttonBorderRadius = cssTag

				if (cmd === 'bFFamily') block.buttonFontFamily = cssTag

				if (cmd === 'bFSize') block.buttonFontSize = cssTag

				if (cmd === 'bBC') block.buttonBorderColor = cssTag

				if (cmd === 'bFH') block.buttonFontHover = cssTag

				if (cmd === 'bFC') block.buttonFontColor = cssTag

				if (cmd === 'bBGH') block.buttonHover = cssTag

				if (cmd === 'bBG') block.buttonBg = cssTag

				if (cmd === 'aBG') block.containerRightBg = cssTag

				if (cmd === 'aLP') block.infoLeftPadding = cssTag

				if (cmd === 'aTFC') block.infoNameColor = cssTag

				if (cmd === 'aTFS') block.infoNameFontSize = cssTag

				if (cmd === 'aTFFamily') block.infoNameFontFamily = cssTag

				if (cmd === 'aTFW') block.infoNameWeight = block.infoNameWeight === 'bold' ? 'normal' : 'bold'

				if (cmd === 'aTFStyle') block.infoNameStyle = block.infoNameStyle === 'italic' ? 'normal' : 'italic'

				if (cmd === 'aTFUnder') block.infoNameDeco = block.infoNameDeco === 'underline' ? 'none' : 'underline'

				if (cmd === 'aDFC') block.infoAddressColor = cssTag

				if (cmd === 'aDFS') block.infoAddressFontSize = cssTag

				if (cmd === 'aDFFamily') block.infoAddressFontFamily = cssTag

				if (cmd === 'cDFFamily') block.infoContactFontFamily = cssTag

				if (cmd === 'aDFW') block.infoAddressWeight = block.infoAddressWeight === 'bold' ? 'normal' : 'bold'

				if (cmd === 'aDFStyle') block.infoAddressStyle = block.infoAddressStyle === 'italic' ? 'normal' : 'italic'

				if (cmd === 'aILC') block.infoContactLeftColor = cssTag

				if (cmd === 'aIFS') block.infoContactFontSize = cssTag

				if (cmd === 'aIRC') block.infoContactRightColor = cssTag

				if (cmd === 'aDLWeight')
					block.infoContactLeftWeight = block.infoContactLeftWeight === 'bold' ? 'normal' : 'bold'

				if (cmd === 'aDLStyle')
					block.infoContactLeftStyle = block.infoContactLeftStyle === 'italic' ? 'normal' : 'italic'

				if (cmd === 'aDRWeight')
					block.infoContactRightWeight = block.infoContactRightWeight === 'bold' ? 'normal' : 'bold'

				if (cmd === 'aDRStyle')
					block.infoContactRightStyle = block.infoContactRightStyle === 'italic' ? 'normal' : 'italic'

				if (cmd === 'mBGC') block.mapBackgroundColor = cssTag

				if (cmd === 'mW') block.mapWidth = cssTag

				if (cmd === 'mH') block.mapHeight = cssTag

				if (cmd === 'mBW') block.mapBorderWidth = cssTag

				if (cmd === 'mSX') block.mapShadowX = cssTag

				if (cmd === 'mSY') block.mapShadowY = cssTag

				if (cmd === 'mSB') block.mapShadowBlur = cssTag

				if (cmd === 'mBC') block.mapBorderColor = cssTag

				if (cmd === 'mSC') block.mapShadowColor = cssTag

				if (cmd === 'setTitlePadding') block.titlePadding = cssTag

				//borders
				if (cmd === 'bL') {
					if (icon16 && selectedIcon === 'icon16') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = 1
						icon16Color = iconHover
						if (icon16 && icon17 && icon18 && icon19) icon20Color = iconHover
					} else {
						block.borderLeftWidth = 0
						icon16Color = iconColor
						icon20Color = iconColor
					}
				}

				if (cmd === 'bT') {
					if (icon17 && selectedIcon === 'icon17') {
						block.borderTopColor = cssTag
						block.borderTopWidth = 1
						icon17Color = iconHover
						if (icon16 && icon17 && icon18 && set_icon_19) icon20Color = iconHover
					} else {
						block.borderTopWidth = 0
						icon17Color = iconColor
						icon20Color = iconColor
					}
				}

				if (cmd === 'bR') {
					if (icon18 && selectedIcon === 'icon18') {
						block.borderRightColor = cssTag
						block.borderRightWidth = 1
						icon18Color = iconHover
						if (icon16 && icon17 && icon18 && icon19) icon20Color = iconHover
					} else {
						block.borderRightWidth = 0
						icon18Color = iconColor
						icon20Color = iconColor
					}
				}

				if (cmd === 'bB') {
					if (icon19 && selectedIcon === 'icon19') {
						block.borderBottomColor = cssTag
						block.borderBottomWidth = 1
						icon19Color = iconHover
						if (icon16 && icon17 && icon18 && icon19) icon20Color = iconHover
					} else {
						block.borderBottomWidth = 0
						icon19Color = iconColor
						icon20Color = iconColor
					}
				}

				if (cmd === 'bA') {
					if (icon20 && selectedIcon === 'icon20') {
						block.borderLeftColor = cssTag
						block.borderLeftWidth = 1
						block.borderTopColor = cssTag
						block.borderTopWidth = 1
						block.borderRightColor = cssTag
						block.borderRightWidth = 1
						block.borderBottomColor = cssTag
						block.borderBottomWidth = 1
						icon20Color = iconHover
						icon16Color = iconHover
						icon17Color = iconHover
						icon18Color = iconHover
						icon19Color = iconHover
					} else {
						block.borderLeftWidth = 0
						block.borderTopWidth = 0
						block.borderRightWidth = 0
						block.borderBottomWidth = 0
						icon20Color = iconColor
						icon16Color = iconColor
						icon17Color = iconColor
						icon18Color = iconColor
						icon19Color = iconColor
						icon16 = false
						icon17 = false
						icon18 = false
						icon19 = false
						icon20 = false
					}
				}

				if (cmd === 'bWidth') {
					if (icon16 && selectedIcon === 'icon16') block.borderLeftWidth = cssTag
					if (icon17 && selectedIcon === 'icon17') block.borderTopWidth = cssTag
					if (icon18 && selectedIcon === 'icon18') block.borderRightWidth = cssTag
					if (icon19 && selectedIcon === 'icon19') block.borderBottomWidth = cssTag
					if (icon20 && selectedIcon === 'icon20') {
						block.borderLeftWidth = cssTag
						block.borderTopWidth = cssTag
						block.borderRightWidth = cssTag
						block.borderBottomWidth = cssTag
					}
				}

				if (cmd === 'bColor') {
					if (icon16 && selectedIcon === 'icon16') block.borderLeftColor = cssTag
					if (icon17 && selectedIcon === 'icon17') block.borderTopColor = cssTag
					if (icon18 && selectedIcon === 'icon18') block.borderRightColor = cssTag
					if (icon19 && selectedIcon === 'icon19') block.borderBottomColor = cssTag
					if (icon20 && selectedIcon === 'icon20') {
						block.borderLeftColor = cssTag
						block.borderTopColor = cssTag
						block.borderRightColor = cssTag
						block.borderBottomColor = cssTag
					}
				}

				if (cmd === 'btRadius') {
					block.borderTopRadius = cssTag
				}

				if (cmd === 'bbRadius') {
					block.borderBottomRadius = cssTag
				}
			}
		})
		config.blocks = blocks
		storeData.set(config)
	}

	const set_icon_BTA = (v) => {
		if (v) {
			if (v === 'flex-start') {
				iconAlignTitleL = iconHover
				iconAlignTitleC = iconColor
				iconAlignTitleR = iconColor
				return
			}
			if (v === 'center') {
				iconAlignTitleL = iconColor
				iconAlignTitleC = iconHover
				iconAlignTitleR = iconColor
				return
			}

			if (v === 'flex-end') {
				iconAlignTitleL = iconColor
				iconAlignTitleC = iconColor
				iconAlignTitleR = iconHover
				return
			}
		}
	}

	const set_icon_BTVA = (v) => {
		if (v) {
			if (v === 'flex-start') {
				icon21Color = iconHover
				icon22Color = iconColor
				icon23Color = iconColor
				return
			}
			if (v === 'center') {
				icon21Color = iconColor
				icon22Color = iconHover
				icon23Color = iconColor
				return
			}

			if (v === 'flex-end') {
				icon21Color = iconColor
				icon22Color = iconColor
				icon23Color = iconHover
				return
			}
		}
	}

	const set_contact_margin_top = (e) => {
		set_css_tag(e.detail.value, 'cMT')
	}

	const set_contact_margin_bottom = (e) => {
		set_css_tag(e.detail.value, 'cMB')
	}

	const set_contact_padding = (e) => {
		set_css_tag(e.detail.value, 'cP')
	}

	const set_contact_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'cSC')
	}

	const set_contact_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'cSX')
	}

	const set_contact_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'cSY')
	}

	const set_contact_shadow_blur = (e) => {
		set_css_tag(e.detail.value, 'cSB')
	}

	const set_contact_info_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'cISX')
	}

	const set_contact_info_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'cISY')
	}

	const set_contact_info_shadow_blur = (e) => {
		set_css_tag(e.detail.value, 'cISB')
	}

	const set_contact_info_padding_top = (e) => {
		set_css_tag(e.detail.value, 'cIPT')
	}

	const set_contact_info_padding_bottom = (e) => {
		set_css_tag(e.detail.value, 'cIPB')
	}

	const set_title_weight = (w) => {
		if (w === 'bold') iconWeightTitle = iconHover
		else iconWeightTitle = iconColor
	}

	const set_details_weight = (w) => {
		if (w === 'bold') iconWeightAddressDetails = iconHover
		else iconWeightAddressDetails = iconColor
	}

	const set_contact_left_weight = (w) => {
		if (w === 'bold') iconWeightContactLeft = iconHover
		else iconWeightContactLeft = iconColor
	}

	const set_contact_left_style = (w) => {
		if (w === 'italic') iconStyleContactLeft = iconHover
		else iconStyleContactLeft = iconColor
	}

	const set_contact_right_weight = (w) => {
		if (w === 'bold') iconWeightContactRight = iconHover
		else iconWeightContactRight = iconColor
	}

	const set_contact_right_style = (w) => {
		if (w === 'italic') iconStyleContactRight = iconHover
		else iconStyleContactRight = iconColor
	}

	const set_details_style = (w) => {
		if (w === 'italic') iconStyleAddressDetails = iconHover
		else iconStyleAddressDetails = iconColor
	}

	const set_address_title_weight = (w) => {
		if (w === 'bold') iconWeightAddressTitle = iconHover
		else iconWeightAddressTitle = iconColor
	}

	const set_title_style = (s) => {
		if (s === 'italic') iconStyleTitle = iconHover
		else iconStyleTitle = iconColor
	}

	const set_address_title_style = (w) => {
		if (w === 'italic') iconStyleAddressTitle = iconHover
		else iconStyleAddressTitle = iconColor
	}

	const set_title_deco = (d) => {
		if (d === 'underline') iconDecoTitle = iconHover
		else iconDecoTitle = iconColor
	}

	const set_address_title_deco = (d) => {
		if (d === 'underline') iconDecoAddressTitle = iconHover
		else iconDecoAddressTitle = iconColor
	}

	const set_title_bg_color = (e) => {
		set_css_tag(e.detail.color, 'tBg')
	}

	const set_block_title_height = (e) => {
		set_css_tag(e.detail.value, 'tH')
	}

	const set_block_title_MT = (e) => {
		set_css_tag(e.detail.value, 'tMT')
	}

	const set_block_title_MB = (e) => {
		set_css_tag(e.detail.value, 'tMB')
	}

	const set_title_font_color = (e) => {
		set_css_tag(e.detail.color, 'tfColor')
	}

	const set_title_font_family = (e) => {
		set_css_tag(e.detail.font, 'tfFamily')
	}

	const set_title_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'tfSize')
	}

	const set_title_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'titleSC')
	}

	const set_title_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'titleSX')
	}

	const set_title_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'titleSY')
	}

	const set_title_shadow_b = (e) => {
		set_css_tag(e.detail.value, 'titleSB')
	}

	const title_bar_align_left = () => {
		set_css_tag('flex-start', 'tfAlign')
	}

	const title_bar_align_center = () => {
		set_css_tag('center', 'tfAlign')
	}

	const title_bar_align_right = () => {
		set_css_tag('flex-end', 'tfAlign')
	}

	const title_bar_valign_top = () => {
		set_css_tag('flex-start', 'tfVAlign')
	}

	const title_bar_valign_center = () => {
		set_css_tag('center', 'tfVAlign')
	}

	const title_bar_valign_bottom = () => {
		set_css_tag('flex-end', 'tfVAlign')
	}

	const title_bar_font_weight = () => {
		iconWeightTitle = iconWeightTitle === iconColor ? iconHover : iconColor
		set_css_tag(null, 'tfWeight')
	}

	const title_bar_font_style = () => {
		set_css_tag(null, 'tfStyle')
	}

	const title_bar_font_deco = () => {
		set_css_tag(null, 'tfUnder')
	}

	const set_contact_title_padding = (e) => {
		set_css_tag(e.detail.value, 'setTitlePadding')
	}

	const set_form_bg_color = (e) => {
		set_css_tag(e.detail.color, 'fBg')
	}

	const set_form_input_color = (e) => {
		set_css_tag(e.detail.color, 'fInput')
	}

	const set_form_input_focus = (e) => {
		set_css_tag(e.detail.color, 'fIFocus')
	}

	const set_form_font_color = (e) => {
		set_css_tag(e.detail.color, 'fColor')
	}

	const set_form_input_border = (e) => {
		set_css_tag(e.detail.color, 'fBorder')
	}

	const set_form_input_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'fSColor')
	}

	const set_input_font_family = (e) => {
		set_css_tag(e.detail.font, 'fFFamily')
	}

	const set_input_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'fFSize')
	}

	const set_button_bg = (e) => {
		set_css_tag(e.detail.color, 'bBG')
	}

	const set_button_hover = (e) => {
		set_css_tag(e.detail.color, 'bBGH')
	}

	const set_button_font_color = (e) => {
		set_css_tag(e.detail.color, 'bFC')
	}

	const set_button_font_hover = (e) => {
		set_css_tag(e.detail.color, 'bFH')
	}

	const set_button_border = (e) => {
		set_css_tag(e.detail.color, 'bBC')
	}

	const set_button_radius = (e) => {
		set_css_tag(e.detail.value, 'bBR')
	}

	const set_button_font_family = (e) => {
		set_css_tag(e.detail.font, 'bFFamily')
	}

	const set_button_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'bFSize')
	}

	const set_address_bg_color = (e) => {
		set_css_tag(e.detail.color, 'aBG')
	}

	const set_address_left_padding = (e) => {
		set_css_tag(e.detail.value, 'aLP')
	}

	const set_address_title_color = (e) => {
		set_css_tag(e.detail.color, 'aTFC')
	}

	const set_address_title_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'aTFS')
	}

	const set_address_title_font_family = (e) => {
		set_css_tag(e.detail.font, 'aTFFamily')
	}

	const set_address_title_font_weight = () => {
		iconWeightAddressDetails = iconWeightAddressDetails === iconColor ? iconHover : iconColor
		set_css_tag(null, 'aTFW')
	}

	const set_address_details_font_weight = () => {
		infoAddressWeight = infoAddressWeight === iconColor ? iconHover : iconColor
		set_css_tag(null, 'aDFW')
	}

	const set_address_details_font_style = () => {
		infoAddressStyle = infoAddressStyle === iconColor ? iconHover : iconColor
		set_css_tag(null, 'aDFStyle')
	}

	const set_address_title_font_style = () => {
		set_css_tag(null, 'aTFStyle')
	}

	const set_address_title_font_deco = () => {
		set_css_tag(null, 'aTFUnder')
	}

	const set_address_details_color = (e) => {
		set_css_tag(e.detail.color, 'aDFC')
	}

	const set_address_details_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'aDFS')
	}

	const set_address_details_font_family = (e) => {
		set_css_tag(e.detail.font, 'aDFFamily')
	}

	const set_contact_details_font_family = (e) => {
		set_css_tag(e.detail.font, 'cDFFamily')
	}

	const set_info_left_color = (e) => {
		set_css_tag(e.detail.color, 'aILC')
	}

	const set_contact_font_size = (e) => {
		const size = string_to_fontsize(e.detail.size)
		set_css_tag(size, 'aIFS')
	}

	const set_info_left_style = () => {
		iconStyleContactLeft = iconStyleContactLeft === iconColor ? iconHover : iconColor
		set_css_tag(null, 'aDLStyle')
	}

	const set_info_left_weight = () => {
		iconWeightContactLeft = iconWeightContactLeft === iconColor ? iconHover : iconColor
		set_css_tag(null, 'aDLWeight')
	}

	const set_info_right_style = () => {
		iconStyleContactRight = iconStyleContactRight === iconColor ? iconHover : iconColor
		set_css_tag(null, 'aDRStyle')
	}

	const set_info_right_weight = () => {
		iconWeightContactRight = iconWeightContactRight === iconColor ? iconHover : iconColor
		set_css_tag(null, 'aDRWeight')
	}

	const set_info_right_color = (e) => {
		set_css_tag(e.detail.color, 'aIRC')
	}

	const set_map_bg_color = (e) => {
		set_css_tag(e.detail.color, 'mBGC')
	}

	const set_map_width = (e) => {
		set_css_tag(e.detail.value, 'mW')
	}

	const set_map_height = (e) => {
		set_css_tag(e.detail.value, 'mH')
	}

	const set_map_border_width = (e) => {
		set_css_tag(e.detail.value, 'mBW')
	}

	const set_map_shadow_x = (e) => {
		set_css_tag(e.detail.value, 'mSX')
	}

	const set_map_shadow_y = (e) => {
		set_css_tag(e.detail.value, 'mSY')
	}

	const set_map_shadow_blur = (e) => {
		set_css_tag(e.detail.value, 'mSB')
	}

	const set_map_border_color = (e) => {
		set_css_tag(e.detail.color, 'mBC')
	}

	const set_map_shadow_color = (e) => {
		set_css_tag(e.detail.color, 'mSC')
	}

	const open_tool = (t) => {
		switch (t) {
			case 'generalTool1':
				generalTool1 = generalTool1 === true ? false : true
				showTool2 = false
				showTool18 = false
				break

			case 'generalTool2':
				generalTool2 = generalTool2 === true ? false : true
				showTool6 = false
				showTool7 = false
				showTool8 = false
				break

			case 'generalTool3':
				generalTool3 = generalTool3 === true ? false : true
				showTool10 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				break

			case 'generalTool4':
				generalTool4 = generalTool4 === true ? false : true
				generalTool5 = false
				break

			case 'generalTool5':
				generalTool5 = generalTool5 === true ? false : true
				generalTool4 = false
				break

			case 'generalTool6':
				generalTool6 = generalTool6 === true ? false : true
				showTool15 = false
				showTool16 = false
				showTool17 = false
				break

			case 0:
				showTool0 = showTool0 === true ? false : true
				showTool1 = false
				showTool3 = false
				showTool4 = false
				showTool5 = false
				showTool9 = false
				showTool14 = false
				break
			case 1:
				showTool1 = showTool1 === true ? false : true
				showTool0 = false
				showTool3 = false
				showTool4 = false
				showTool5 = false
				showTool9 = false
				showTool14 = false
				break

			case 2:
				showTool2 = showTool2 === true ? false : true
				generalTool1 = false
				showTool18 = false
				break

			case 3:
				showTool3 = showTool3 === true ? false : true
				showTool1 = false
				showTool0 = false
				showTool4 = false
				showTool5 = false
				showTool9 = false
				showTool14 = false
				break

			case 4:
				showTool4 = showTool4 === true ? false : true
				showTool1 = false
				showTool3 = false
				showTool0 = false
				showTool5 = false
				showTool9 = false
				showTool14 = false
				break

			case 5:
				showTool5 = showTool5 === true ? false : true
				showTool1 = false
				showTool3 = false
				showTool4 = false
				showTool0 = false
				showTool9 = false
				showTool14 = false
				break

			case 6:
				showTool6 = showTool6 === true ? false : true
				generalTool2 = false
				showTool7 = false
				showTool8 = false
				break

			case 7:
				showTool7 = showTool7 === true ? false : true
				generalTool2 = false
				showTool6 = false
				showTool8 = false
				break

			case 8:
				showTool8 = showTool8 === true ? false : true
				generalTool2 = false
				showTool7 = false
				showTool6 = false
				break

			case 9:
				showTool9 = showTool9 === true ? false : true
				showTool1 = false
				showTool3 = false
				showTool4 = false
				showTool5 = false
				showTool0 = false
				showTool14 = false
				break

			case 10:
				showTool10 = showTool10 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool12 = false
				showTool13 = false
				break

			case 11:
				showTool11 = showTool11 === true ? false : true
				generalTool3 = false
				showTool10 = false
				showTool12 = false
				showTool13 = false
				break

			case 12:
				showTool12 = showTool12 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool10 = false
				showTool13 = false
				break

			case 13:
				showTool13 = showTool13 === true ? false : true
				generalTool3 = false
				showTool11 = false
				showTool12 = false
				showTool10 = false
				break

			case 14:
				showTool14 = showTool14 === true ? false : true
				showTool1 = false
				showTool3 = false
				showTool4 = false
				showTool5 = false
				showTool9 = false
				showTool0 = false
				break

			case 15:
				showTool15 = showTool15 === true ? false : true
				generalTool6 = false
				showTool16 = false
				showTool17 = false
				break

			case 16:
				showTool16 = showTool16 === true ? false : true
				generalTool6 = false
				showTool15 = false
				showTool17 = false
				break

			case 17:
				showTool17 = showTool17 === true ? false : true
				generalTool6 = false
				showTool16 = false
				showTool15 = false
				break

			case 18:
				showTool18 = showTool18 === true ? false : true
				generalTool1 = false
				showTool2 = false
				break
		}
	}

	const change_order = async (block, direction) => {
		storeContact.set(false)

		let changeOrder = true
		let blocks = get_blocks(config)
		blocks.forEach((bl, index) => {
			if (bl.blockName === block) {
				if (config.blocks[index].layoutOrder === 0 && direction === 'up') {
					changeOrder = false
				}
				if (config.blocks[index].layoutOrder === blocks.length - 1 && direction === 'down') {
					changeOrder = false
				}
			}
		})

		if (changeOrder) {
			shaderChangeOrder = true
			const reorder = await reorder_layout(block, direction)
			storeData.set(reorder)
			shaderChangeOrder = false
		}
	}

	/***** BORDERS *****/
	let iconSelected
	//icon selected
	let selectedIcon
	let selectedBorderColor = 'hsla(0,0%,0%,1)'
	let selectedStoreIcon
	const stoSelectedIcon = storeSelectedIcon.subscribe((value) => {
		selectedStoreIcon = value
	})

	//the values to send to sizeSelectors
	let selectedBorderWidth

	$: if (!icon16 && !icon17 && !icon18 && !icon19 && !icon20) iconSelected = false

	$: if (selectedStoreIcon === 'icon16') selectedBorderWidth = borderLeftWidth
	$: if (selectedStoreIcon === 'icon17') selectedBorderWidth = borderTopWidth
	$: if (selectedStoreIcon === 'icon18') selectedBorderWidth = borderRightWidth
	$: if (selectedStoreIcon === 'icon19') selectedBorderWidth = borderBottomWidth
	$: if (selectedStoreIcon === 'icon20') selectedBorderWidth = borderLeftWidth

	const set_icon_color = (cmd, c) => {
		if (cmd === 'Block') {
			if (c === 'left') icon16Color = iconHover
			if (c === 'top') icon17Color = iconHover
			if (c === 'right') icon18Color = iconHover
			if (c === 'bottom') icon19Color = iconHover
			if (c === 'all') {
				icon16Color = iconHover
				icon17Color = iconHover
				icon18Color = iconHover
				icon19Color = iconHover
				icon20Color = iconHover
			}
			if (c === 'none') {
				icon16Color = iconColor
				icon17Color = iconColor
				icon18Color = iconColor
				icon19Color = iconColor
				icon20Color = iconColor
			}
		}
	}

	const set_border_color = (e) => {
		set_css_tag(e.detail.color, 'bColor')
	}

	const set_border_width = (e) => {
		set_css_tag(e.detail.value, 'bWidth')
	}

	const set_border_top_radius = (e) => {
		set_css_tag(e.detail.value, 'btRadius')
	}

	const set_border_bottom_radius = (e) => {
		set_css_tag(e.detail.value, 'bbRadius')
	}

	const set_icon_16 = () => {
		iconSelected = true
		selectedIcon = 'icon16'
		storeSelectedIcon.set('icon16')
		icon16 = icon16 === false ? true : false
		if (icon16) icon16Color = iconHover
		else icon16Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bL')
	}

	const set_icon_17 = () => {
		iconSelected = true
		selectedIcon = 'icon17'
		storeSelectedIcon.set('icon17')
		icon17 = icon17 === false ? true : false
		if (icon17) icon17Color = iconHover
		else icon17Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bT')
	}

	const set_icon_18 = () => {
		iconSelected = true
		selectedIcon = 'icon18'
		storeSelectedIcon.set('icon18')
		icon18 = icon18 === false ? true : false
		if (icon18) icon18Color = iconHover
		else icon18Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bR')
	}

	const set_icon_19 = () => {
		iconSelected = true
		selectedIcon = 'icon19'
		storeSelectedIcon.set('icon19')
		icon19 = icon19 === false ? true : false
		if (icon19) icon19Color = iconHover
		else icon19Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bB')
	}

	const set_icon_20 = () => {
		iconSelected = true
		selectedIcon = 'icon20'
		storeSelectedIcon.set('icon20')
		icon20 = icon20 === false ? true : false
		if (icon20) icon20Color = iconHover
		else icon20Color = iconColor
		set_css_tag('hsla(0,0%,0%,1)', 'bA')
	}

	onDestroy(() => {
		stoElementID
		stoData
		stoSelectedIcon
	})
</script>

{#if config}
	<main id="contact" use:styles={{ width }}>
		<div
			class="part_title mainTool"
			on:click={() => open_tool(0)}
			on:keydown={() => open_tool(0)}
			use:styles={{ mainTool, mainToolHover, fsXS }}
		>
			LAYOUT POSITION
		</div>
		{#if showTool0}
			<div transition:slide={{ duration: 500 }}>
				<div class="icon_container">
					<div
						class="icon arrow_down"
						use:styles={{ icon, iconColor, iconHover }}
						on:click={() => change_order('contact', 'down')}
						on:keydown={() => change_order('contact', 'down')}
					/>
					<div
						class="icon arrow_up"
						use:styles={{ icon, iconColor, iconHover }}
						on:click={() => change_order('contact', 'up')}
						on:keydown={() => change_order('contact', 'up')}
					/>
				</div>
			</div>
		{/if}
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(1)}
				on:keydown={() => open_tool(1)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				CONTAINER
			</div>
			{#if showTool1}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool1')}
						on:keydown={() => open_tool('generalTool1')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool1}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector
								ID={idMarginTop}
								range="10"
								initialValue={marginTop}
								on:sizechange={set_contact_margin_top}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector
								ID={idMarginBottom}
								range="10"
								initialValue={marginBottom}
								on:sizechange={set_contact_margin_bottom}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector ID={idPadding} range="5" initialValue={padding} on:sizechange={set_contact_padding} />
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(18)}
						on:keydown={() => open_tool(18)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						border
					</div>
					{#if showTool18}
						<div transition:slide={{ duration: 500 }}>
							<div class="icon_container">
								<div
									id="icon16"
									class="icon icon16"
									use:styles={{ icon, icon16Color, iconHover }}
									on:click={set_icon_16}
									on:keydown={set_icon_16}
								/>
								<div
									id="icon17"
									class="icon icon17"
									use:styles={{ icon, icon17Color, iconHover }}
									on:click={set_icon_17}
									on:keydown={set_icon_17}
								/>
								<div
									id="icon18"
									class="icon icon18"
									use:styles={{ icon, icon18Color, iconHover }}
									on:click={set_icon_18}
									on:keydown={set_icon_18}
								/>
								<div
									id="icon19"
									class="icon icon19"
									use:styles={{ icon, icon19Color, iconHover }}
									on:click={set_icon_19}
									on:keydown={set_icon_19}
								/>
								<div
									id="icon20"
									class="icon icon20"
									use:styles={{ icon, icon20Color, iconHover }}
									on:click={set_icon_20}
									on:keydown={set_icon_20}
								/>
							</div>
							{#if iconSelected}
								<div in:slide={{ duration: 500 }}>
									<div class="sub_title" use:styles={{ fsXS }}>Color</div>
									<ColorSelector
										on:setcolor={set_border_color}
										transparent={false}
										ID={idColor2}
										selectedColor={selectedBorderColor}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Width</div>
									<SizeSelector
										ID={idBorderWidth}
										range="50"
										unit="px"
										initialValue={selectedBorderWidth}
										on:sizechange={set_border_width}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Top Radius</div>
									<SizeSelector
										ID={idBTradius}
										initialValue={borderTopRadius}
										unit="px"
										range="20"
										on:sizechange={set_border_top_radius}
									/>

									<div class="sub_title" use:styles={{ fsXS }}>Bottom Radius</div>
									<SizeSelector
										ID={idBBradius}
										initialValue={borderBottomRadius}
										range="20"
										unit="px"
										on:sizechange={set_border_bottom_radius}
									/>
								</div>
							{/if}
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(2)}
						on:keydown={() => open_tool(2)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						shadow
					</div>
					{#if showTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Shadow Color</div>
							<ColorSelector
								on:setcolor={set_contact_shadow_color}
								showTranparency={false}
								ID={idColor8}
								selectedColor={shadowColor}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idShadowX}
								range="10"
								unit="px"
								initialValue={shadowX}
								on:sizechange={set_contact_shadow_x}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idShadowY}
								range="10"
								unit="px"
								initialValue={shadowY}
								on:sizechange={set_contact_shadow_y}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idShadowBlur}
								range="10"
								unit="px"
								initialValue={shadowBlur}
								on:sizechange={set_contact_shadow_blur}
							/>
						</div>
					{/if}
				</div>
			{/if}
		</section>
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(3)}
				on:keydown={() => open_tool(3)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				TITLE CONTAINER
			</div>
			{#if showTool3}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool4')}
						on:keydown={() => open_tool('generalTool4')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool4}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_title_bg_color}
								on:setopacity={set_title_bg_color}
								on:settransparent={set_title_bg_color}
								transparent="1"
								ID={idColor1}
								selectedColor={titleBackgroundColor}
								initialValue={titleBgOpac}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Height</div>

							<SizeSelector
								ID={idTitleHeight}
								range="500"
								unit="px"
								initialValue={blockTitleHeight}
								on:sizechange={set_block_title_height}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Margin Top</div>
							<SizeSelector ID={idTitleMT} range="5" initialValue={blockTitleMT} on:sizechange={set_block_title_MT} />

							<div class="sub_title" use:styles={{ fsXS }}>Margin Bottom</div>
							<SizeSelector ID={idTitleMB} range="5" initialValue={blockTitleMB} on:sizechange={set_block_title_MB} />

							<div class="sub_title" use:styles={{ fsXS }}>Padding</div>
							<SizeSelector
								ID={idTitlePadding}
								range="20"
								initialValue={titlePadding}
								on:sizechange={set_contact_title_padding}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool5')}
						on:keydown={() => open_tool('generalTool5')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						font
					</div>
					{#if generalTool5}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector
								on:setcolor={set_title_font_color}
								on:setopacity={set_title_font_color}
								on:settransparent={set_title_font_color}
								transparent="1"
								ID={idColor2}
								selectedColor={titleColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_title_font_family}
								value={titleFontFamily}
								ID={idSelect1}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues options={fontSize} on:select={set_title_font_size} value={titleFontSize} ID={idSelect2} />

							<div class="sub_title" use:styles={{ fsXS }}>Font Alignment</div>
							<div class="icon_container">
								<div
									id="icon1"
									class="icon icon1"
									use:styles={{ icon, iconAlignTitleL, iconHover }}
									on:click={title_bar_align_left}
									on:keydown={title_bar_align_left}
								/>
								<div
									id="icon2"
									class="icon icon2"
									use:styles={{ icon, iconAlignTitleC, iconHover }}
									on:click={title_bar_align_center}
									on:keydown={title_bar_align_center}
								/>
								<div
									id="icon3"
									class="icon icon3"
									use:styles={{ icon, iconAlignTitleR, iconHover }}
									on:click={title_bar_align_right}
									on:keydown={title_bar_align_right}
								/>
							</div>

							<div class="icon_container">
								<div
									id="icon21"
									class="icon icon21"
									use:styles={{ icon, icon21Color, iconHover }}
									on:click={title_bar_valign_top}
									on:keydown={title_bar_valign_top}
								/>
								<div
									id="icon22"
									class="icon icon22"
									use:styles={{ icon, icon22Color, iconHover }}
									on:click={title_bar_valign_center}
									on:keydown={title_bar_valign_center}
								/>
								<div
									id="icon23"
									class="icon icon23"
									use:styles={{ icon, icon23Color, iconHover }}
									on:click={title_bar_valign_bottom}
									on:keydown={title_bar_valign_bottom}
								/>
							</div>

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="icon4"
									class="icon icon4"
									use:styles={{ icon, iconWeightTitle, iconHover }}
									on:click={title_bar_font_weight}
									on:keydown={title_bar_font_weight}
								/>
								<div
									id="icon5"
									class="icon icon5"
									use:styles={{ icon, iconStyleTitle, iconHover }}
									on:click={title_bar_font_style}
									on:keydown={title_bar_font_style}
								/>
								<div
									id="icon6"
									class="icon icon6"
									use:styles={{ icon, iconDecoTitle, iconHover }}
									on:click={title_bar_font_deco}
									on:keydown={title_bar_font_deco}
								/>
							</div>

							<div class="sub_title" use:styles={{ fsXS }}>font - shadow</div>

							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_title_shadow_color}
								on:setopacity={set_title_shadow_color}
								ID={idColor23}
								showTranparency={false}
								selectedColor={tSC}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector ID={idTSX} range="20" unit="px" initialValue={tSX} on:sizechange={set_title_shadow_x} />

							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector ID={idTSY} range="20" unit="px" initialValue={tSY} on:sizechange={set_title_shadow_y} />

							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector ID={idTSB} range="20" unit="px" initialValue={tSB} on:sizechange={set_title_shadow_b} />
						</div>
					{/if}
				</div>
			{/if}
		</section>
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(4)}
				on:keydown={() => open_tool(4)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				POP-UP CONTAINER
			</div>
			{#if showTool4}
				<div transition:slide={{ duration: 500 }}>
					<div class="sub_title" use:styles={{ fsXS }}>Padding Top</div>
					<SizeSelector
						ID={idFormPaddingTop}
						range="10"
						initialValue={containerLeftPaddingTop}
						on:sizechange={set_contact_info_padding_top}
					/>
					<div class="sub_title" use:styles={{ fsXS }}>Padding Bottom</div>
					<SizeSelector
						ID={idFormPaddingBottom}
						range="10"
						initialValue={containerLeftPaddingBottom}
						on:sizechange={set_contact_info_padding_bottom}
					/>
				</div>
			{/if}
		</section>
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(5)}
				on:keydown={() => open_tool(5)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				FORM
			</div>
			{#if showTool5}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool2')}
						on:keydown={() => open_tool('generalTool2')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool2}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_form_bg_color}
								on:setopacity={set_form_bg_color}
								on:settransparent={set_form_bg_color}
								transparent="1"
								ID={idColor3}
								selectedColor={containerLeftBg}
								initialValue={containerLeftOpac}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(6)}
						on:keydown={() => open_tool(6)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						input fields
					</div>
					{#if showTool6}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_form_input_color}
								showTranparency={false}
								ID={idColor4}
								selectedColor={inputBg}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Focus Color</div>
							<ColorSelector
								on:setcolor={set_form_input_focus}
								showTranparency={false}
								ID={idColor9}
								selectedColor={inputFocus}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector
								on:setcolor={set_form_font_color}
								showTranparency={false}
								ID={idColor5}
								selectedColor={inputFontColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
							<ColorSelector
								on:setcolor={set_form_input_border}
								showTranparency={false}
								ID={idColor6}
								selectedColor={inputBorder}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_input_font_family}
								value={inputFontFamily}
								ID={idSelect1}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues options={fontSize} on:select={set_input_font_size} value={inputFontSize} ID={idSelect2} />
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(7)}
						on:keydown={() => open_tool(7)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						input/button shadow
					</div>
					{#if showTool7}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Input Shadow</div>
							<ColorSelector
								on:setcolor={set_form_input_shadow_color}
								showTranparency={false}
								ID={idColor7}
								selectedColor={inputShadowColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
							<SizeSelector
								ID={idInputShadowX}
								range="10"
								unit="px"
								initialValue={inputShadowX}
								on:sizechange={set_contact_info_shadow_x}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
							<SizeSelector
								ID={idInputShadowY}
								range="10"
								unit="px"
								initialValue={inputShadowY}
								on:sizechange={set_contact_info_shadow_y}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
							<SizeSelector
								ID={idInputShadowBlur}
								range="10"
								unit="px"
								initialValue={inputShadowBlur}
								on:sizechange={set_contact_info_shadow_blur}
							/>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(8)}
						on:keydown={() => open_tool(8)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						send button
					</div>
					{#if showTool8}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_button_bg}
								showTranparency={false}
								ID={idColor10}
								selectedColor={buttonBg}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Hover</div>
							<ColorSelector
								on:setcolor={set_button_hover}
								showTranparency={false}
								ID={idColor11}
								selectedColor={buttonHover}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Color</div>
							<ColorSelector
								on:setcolor={set_button_font_color}
								showTranparency={false}
								ID={idColor12}
								selectedColor={buttonFontColor}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Font Hover</div>
							<ColorSelector
								on:setcolor={set_button_font_hover}
								showTranparency={false}
								ID={idColor13}
								selectedColor={buttonFontHover}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Border Color</div>
							<ColorSelector
								on:setcolor={set_button_border}
								showTranparency={false}
								ID={idColor14}
								selectedColor={buttonBorderColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Border Radius</div>
							<SizeSelector
								ID={idButtonRadius}
								range="20"
								unit="px"
								initialValue={buttonBorderRadius}
								on:sizechange={set_button_radius}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_button_font_family}
								value={buttonFontFamily}
								ID={idSelect1}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues options={fontSize} on:select={set_button_font_size} value={buttonFontSize} ID={idSelect2} />
						</div>
					{/if}
				</div>
			{/if}
		</section>
		<section>
			<div
				class="part_title mainTool"
				on:click={() => open_tool(9)}
				on:keydown={() => open_tool(9)}
				use:styles={{ mainTool, mainToolHover, fsXS }}
			>
				ADDRESS CONTAINER
			</div>
			{#if showTool9}
				<div transition:slide={{ duration: 500 }}>
					<div
						class="part_title subTool"
						on:click={() => open_tool('generalTool3')}
						on:keydown={() => open_tool('generalTool3')}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						general
					</div>
					{#if generalTool3}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Background</div>
							<ColorSelector
								on:setcolor={set_address_bg_color}
								on:setopacity={set_address_bg_color}
								on:settransparent={set_address_bg_color}
								transparent="1"
								ID={idColor15}
								selectedColor={containerRightBg}
								initialValue={containerRightOpac}
							/>
							<div class="sub_title" use:styles={{ fsXS }}>Padding Left</div>
							<SizeSelector
								ID={idInfoLeftPadding}
								range="10"
								unit="%"
								initialValue={infoLeftPadding}
								on:sizechange={set_address_left_padding}
							/>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(10)}
						on:keydown={() => open_tool(10)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						company/name
					</div>
					{#if showTool10}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_address_title_color}
								ID={idColor16}
								showTranparency={false}
								selectedColor={infoNameColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_address_title_font_family}
								value={infoNameFontFamily}
								ID={idSelect1}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_address_title_font_size}
								value={infoNameFontSize}
								ID={idSelect2}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="icon7"
									class="icon icon7"
									use:styles={{ icon, iconWeightAddressTitle, iconHover }}
									on:click={set_address_title_font_weight}
									on:keydown={set_address_title_font_weight}
								/>
								<div
									id="icon8"
									class="icon icon8"
									use:styles={{ icon, iconStyleAddressTitle, iconHover }}
									on:click={set_address_title_font_style}
									on:keydown={set_address_title_font_style}
								/>
								<div
									id="icon9"
									class="icon icon9"
									use:styles={{ icon, iconDecoAddressTitle, iconHover }}
									on:click={set_address_title_font_deco}
									on:keydown={set_address_title_font_deco}
								/>
							</div>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(11)}
						on:keydown={() => open_tool(11)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						address
					</div>
					{#if showTool11}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_address_details_color}
								ID={idColor17}
								showTranparency={false}
								selectedColor={infoAddressColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_address_details_font_family}
								value={infoAddressFontFamily}
								ID={idSelect1}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_address_details_font_size}
								value={infoAddressFontSize}
								ID={idSelect2}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="icon10"
									class="icon icon10"
									use:styles={{ icon, iconWeightAddressDetails, iconHover }}
									on:click={set_address_details_font_weight}
									on:keydown={set_address_details_font_weight}
								/>
								<div
									id="icon11"
									class="icon icon11"
									use:styles={{ icon, iconStyleAddressDetails, iconHover }}
									on:click={set_address_details_font_style}
									on:keydown={set_address_details_font_style}
								/>
							</div>
						</div>
					{/if}
					<div
						class="part_title subTool"
						on:click={() => open_tool(12)}
						on:keydown={() => open_tool(12)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						phone/fax/mail
					</div>
					{#if showTool12}
						<div transition:slide={{ duration: 500 }}>
							<div class="sub_title" use:styles={{ fsXS }}>Color</div>
							<ColorSelector
								on:setcolor={set_info_left_color}
								ID={idColor18}
								showTranparency={false}
								selectedColor={infoContactLeftColor}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Family</div>
							<SelectValues
								options={fontFamily}
								on:select={set_contact_details_font_family}
								value={infoContactFontFamily}
								ID={idSelect1}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Size</div>
							<SelectValues
								options={fontSize}
								on:select={set_contact_font_size}
								value={infoContactFontSize}
								ID={idSelect2}
							/>

							<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
							<div class="icon_container">
								<div
									id="icon12"
									class="icon icon12"
									use:styles={{ icon, iconWeightContactLeft, iconHover }}
									on:click={set_info_left_weight}
									on:keydown={set_info_left_weight}
								/>
								<div
									id="icon13"
									class="icon icon13"
									use:styles={{ icon, iconStyleContactLeft, iconHover }}
									on:click={set_info_left_style}
									on:keydown={set_info_left_style}
								/>
							</div>
						</div>
					{/if}

					<div
						class="part_title subTool"
						on:click={() => open_tool(13)}
						on:keydown={() => open_tool(13)}
						use:styles={{ subTool, subToolHover, fsXS }}
					>
						contact
					</div>
					{#if showTool13}
						<div transition:slide={{ duration: 500 }}>
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title" use:styles={{ fsXS }}>Color</div>
								<ColorSelector
									on:setcolor={set_info_right_color}
									ID={idColor19}
									showTranparency={false}
									selectedColor={infoContactRightColor}
								/>
								<div class="sub_title" use:styles={{ fsXS }}>Font Decoration</div>
								<div class="icon_container">
									<div
										id="icon14"
										class="icon icon14"
										use:styles={{ icon, iconWeightContactRight, iconHover }}
										on:click={set_info_right_weight}
										on:keydown={set_info_right_weight}
									/>
									<div
										id="icon15"
										class="icon icon15"
										use:styles={{ icon, iconStyleContactRight, iconHover }}
										on:click={set_info_right_style}
										on:keydown={set_info_right_style}
									/>
								</div>
							</div>
						</div>
					{/if}
				</div>
			{/if}
		</section>
		{#if map}
			<section>
				<div
					class="part_title mainTool"
					on:click={() => open_tool(14)}
					on:keydown={() => open_tool(14)}
					use:styles={{ mainTool, mainToolHover, fsXS }}
				>
					MAP
				</div>
				{#if showTool14}
					<div transition:slide={{ duration: 500 }}>
						<div
							class="part_title subTool"
							on:click={() => open_tool('generalTool6')}
							on:keydown={() => open_tool('generalTool6')}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							general
						</div>
						{#if generalTool6}
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title" use:styles={{ fsXS }}>Background Color</div>
								<ColorSelector
									on:setcolor={set_map_bg_color}
									on:setopacity={set_map_bg_color}
									on:settransparent={set_map_bg_color}
									ID={idColor22}
									transparent="1"
									selectedColor={mapBgColor}
									initialValue={mapBgOpac}
								/>
								<div class="sub_title" use:styles={{ fsXS }}>Width</div>
								<SizeSelector
									ID={idMapWidth}
									range="100"
									unit="%"
									initialValue={mapWidth}
									on:sizechange={set_map_width}
								/>
								<div class="sub_title" use:styles={{ fsXS }}>Height</div>
								<SizeSelector
									ID={idMapHeigth}
									range="100"
									unit="%"
									initialValue={mapHeight}
									on:sizechange={set_map_height}
								/>
							</div>
						{/if}
						<div
							class="part_title subTool"
							on:click={() => open_tool(15)}
							on:keydown={() => open_tool(15)}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							border
						</div>
						{#if showTool15}
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title" use:styles={{ fsXS }}>Color</div>
								<ColorSelector
									on:setcolor={set_map_border_color}
									ID={idColor20}
									showTranparency={false}
									selectedColor={mapBorderColor}
								/>
								<div class="sub_title" use:styles={{ fsXS }}>Width</div>
								<SizeSelector
									ID={idMapBorderWidth}
									range="10"
									unit="px"
									initialValue={mapBorderWidth}
									on:sizechange={set_map_border_width}
								/>
							</div>
						{/if}

						<div
							class="part_title subTool"
							on:click={() => open_tool(16)}
							on:keydown={() => open_tool(16)}
							use:styles={{ subTool, subToolHover, fsXS }}
						>
							shadow
						</div>
						{#if showTool16}
							<div transition:slide={{ duration: 500 }}>
								<div class="sub_title" use:styles={{ fsXS }}>Shadow Color</div>
								<ColorSelector
									on:setcolor={set_map_shadow_color}
									ID={idColor21}
									showTranparency={false}
									selectedColor={mapShadowColor}
								/>
								<div class="sub_title" use:styles={{ fsXS }}>Offset X</div>
								<SizeSelector
									ID={idMapShadowX}
									range="10"
									unit="px"
									initialValue={mapShadowX}
									on:sizechange={set_map_shadow_x}
								/>
								<div class="sub_title" use:styles={{ fsXS }}>Offset Y</div>
								<SizeSelector
									ID={idMapShadowY}
									range="10"
									unit="px"
									initialValue={mapShadowY}
									on:sizechange={set_map_shadow_y}
								/>
								<div class="sub_title" use:styles={{ fsXS }}>Blur</div>
								<SizeSelector
									ID={idMapShadowBlur}
									range="10"
									unit="px"
									initialValue={mapShadowBlur}
									on:sizechange={set_map_shadow_blur}
								/>
							</div>
						{/if}
					</div>
				{/if}
			</section>
		{/if}
	</main>
{/if}

{#if shaderChangeOrder}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="change block order" />
		</div>
	</Shader>
{/if}

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		font-size: var(--fsXS);
		padding: 10px;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.icon_container {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
		padding: 2%;
	}

	.icon {
		display: inline-block;
		width: var(--icon);
		height: var(--icon);
		background-color: var(--iconColor);
		mask-size: cover;
		-webkit-mask-size: cover;
		cursor: pointer;
	}

	.icon:hover {
		background-color: var(--iconHover);
	}

	.arrow_down {
		mask: url('/images/tools/arrow_down.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_down.svg') no-repeat;
	}

	.arrow_up {
		mask: url('/images/tools/arrow_up.svg') no-repeat;
		-webkit-mask: url('/images/tools/arrow_up.svg') no-repeat;
	}

	.icon1 {
		background-color: var(--iconAlignTitleL);
		mask: url('/images/tools/alignL.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignL.svg') no-repeat;
	}

	.icon2 {
		background-color: var(--iconAlignTitleC);
		mask: url('/images/tools/alignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignC.svg') no-repeat;
	}

	.icon3 {
		background-color: var(--iconAlignTitleR);
		mask: url('/images/tools/alignR.svg') no-repeat;
		-webkit-mask: url('/images/tools/alignR.svg') no-repeat;
	}

	.icon4 {
		background-color: var(--iconWeightTitle);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.icon5 {
		background-color: var(--iconStyleTitle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.icon6 {
		background-color: var(--iconDecoTitle);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.icon7 {
		background-color: var(--iconWeightAddressTitle);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.icon8 {
		background-color: var(--iconStyleAddressTitle);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.icon9 {
		background-color: var(--iconDecoAddressTitle);
		mask: url('/images/tools/fontU.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontU.svg') no-repeat;
	}

	.icon10 {
		background-color: var(--iconWeightAddressDetails);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.icon11 {
		background-color: var(--iconStyleAddressDetails);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.icon12 {
		background-color: var(--iconWeightContactLeft);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.icon13 {
		background-color: var(--iconStyleContactLeft);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.icon14 {
		background-color: var(--iconWeightContactRight);
		mask: url('/images/tools/fontB.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontB.svg') no-repeat;
	}

	.icon15 {
		background-color: var(--iconStyleContactRight);
		mask: url('/images/tools/fontI.svg') no-repeat;
		-webkit-mask: url('/images/tools/fontI.svg') no-repeat;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}

	.subTool {
		background-color: var(--subTool);
	}

	.subTool:hover {
		background-color: var(--subToolHover);
	}

	.icon16 {
		background-color: var(--icon16Color);
		mask: url('/images/tools/borderL.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderL.svg') no-repeat;
	}

	.icon17 {
		background-color: var(--icon17Color);
		mask: url('/images/tools/borderT.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderT.svg') no-repeat;
	}

	.icon18 {
		background-color: var(--icon18Color);
		mask: url('/images/tools/borderR.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderR.svg') no-repeat;
	}

	.icon19 {
		background-color: var(--icon19Color);
		mask: url('/images/tools/borderB.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderB.svg') no-repeat;
	}

	.icon20 {
		background-color: var(--icon20Color);
		mask: url('/images/tools/borderA.svg') no-repeat;
		-webkit-mask: url('/images/tools/borderA.svg') no-repeat;
	}

	.icon21 {
		background-color: var(--icon21Color);
		mask: url('/images/tools/valignT.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignT.svg') no-repeat;
	}

	.icon22 {
		background-color: var(--icon22Color);
		mask: url('/images/tools/valignC.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignC.svg') no-repeat;
	}

	.icon23 {
		background-color: var(--icon23Color);
		mask: url('/images/tools/valignB.svg') no-repeat;
		-webkit-mask: url('/images/tools/valignB.svg') no-repeat;
	}
</style>
